export const INTRO_SESSION_KEY = "orkest-brand-intro-seen"
export const INTRO_MAX_MS = 4000

// Runs in the document head before the body can paint.
export const INTRO_BOOTSTRAP = `
  try {
    if (sessionStorage.getItem('${INTRO_SESSION_KEY}') === '1') {
      document.documentElement.setAttribute('data-intro', 'seen');
    }
  } catch {}
  if (document.documentElement.getAttribute('data-intro') !== 'seen') {
    document.documentElement.setAttribute('data-intro-start', String(Date.now()));
    setTimeout(function () {
      if (document.documentElement.getAttribute('data-intro') !== 'seen') {
        document.documentElement.setAttribute('data-intro', 'seen');
        try { sessionStorage.setItem('${INTRO_SESSION_KEY}', '1'); } catch {}
      }
    }, ${INTRO_MAX_MS});
  }
`
